import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "record-card__title"
}
const _hoisted_2 = {
  key: 1,
  "data-test": "record-card-aside",
  class: "record-card__aside"
}
const _hoisted_3 = {
  key: 2,
  class: "record-card__actions"
}
const _hoisted_4 = {
  key: 1,
  class: "record-card__subtitle"
}
const _hoisted_5 = {
  key: 2,
  "data-test": "record-card-foot",
  class: "record-card__foot"
}


export default {
  __name: 'RecordCard',
  props: {
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  aside: { type: String, default: '' },
  danger: { type: Boolean, default: false }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["record-card", __props.danger && 'record-card--danger'])
  }, [
    (__props.title || __props.aside || _ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "data-test": "record-card-head",
          class: _normalizeClass(["record-card__head", __props.subtitle && 'record-card__head--tight'])
        }, [
          (__props.title)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(__props.title), 1))
            : _createCommentVNode("", true),
          (__props.aside)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.aside), 1))
            : _createCommentVNode("", true),
          (_ctx.$slots.actions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "actions")
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (__props.subtitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.subtitle), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

}